import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { Wine } from "lucide-react";
import { useAuth } from "@/context/AuthContext";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { Button } from "@/components/ui/button";

export default function AdminLogin() {
  const { login, error } = useAuth();
  const navigate = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    const ok = await login(email, password);
    setLoading(false);
    if (ok) navigate("/admin");
  };

  return (
    <div className="min-h-screen flex items-center justify-center px-6 hero-radial grain" data-testid="admin-login-page">
      <div className="w-full max-w-md rounded-2xl border border-white/10 bg-card/60 p-10 glass">
        <div className="flex items-center gap-3">
          <span className="w-10 h-10 rounded-full bg-primary/15 border border-primary/30 flex items-center justify-center text-primary">
            <Wine size={20} strokeWidth={1.5} />
          </span>
          <div>
            <div className="font-display text-2xl">Pinkies Up</div>
            <div className="overline text-primary/80">Admin sign in</div>
          </div>
        </div>

        <form onSubmit={submit} className="mt-10 space-y-5" data-testid="login-form">
          <div>
            <Label className="overline">Email</Label>
            <Input required type="email" value={email} onChange={(e) => setEmail(e.target.value)} className="mt-2 bg-secondary/40 border-white/10" data-testid="login-email" />
          </div>
          <div>
            <Label className="overline">Password</Label>
            <Input required type="password" value={password} onChange={(e) => setPassword(e.target.value)} className="mt-2 bg-secondary/40 border-white/10" data-testid="login-password" />
          </div>
          {error && (
            <div className="text-sm text-destructive-foreground bg-destructive/15 border border-destructive/30 rounded-md px-3 py-2" data-testid="login-error">
              {error}
            </div>
          )}
          <Button type="submit" disabled={loading} className="w-full rounded-full py-3 bg-primary text-primary-foreground hover:bg-primary/90" data-testid="login-submit">
            {loading ? "Signing in..." : "Sign in"}
          </Button>
        </form>
      </div>
    </div>
  );
}
